import { render, staticRenderFns } from "./InventoryDashboard.vue?vue&type=template&id=a257dfd8&scoped=true"
import script from "./InventoryDashboard.vue?vue&type=script&lang=js"
export * from "./InventoryDashboard.vue?vue&type=script&lang=js"
import style0 from "./InventoryDashboard.vue?vue&type=style&index=0&id=a257dfd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a257dfd8",
  null
  
)

export default component.exports